<div class="hotel-tour" [class.hotel-tour--hotels-search]="isHotelsSearch">

    <div class="hotel-tour-bar">
        <div class="ng-flex">
            @if (tour.isBestPrice) {
                <div class="hotel-tour-bar-label hotel-tour-bar-label__best-sale">
                    Выгодная цена
                </div>
            } @else if (tour.discount) {
                <div class="hotel-tour-bar-label hotel-tour-bar-label__discount">
                    -{{ tour.discount }}%
                </div>
            }

            @if (tour.instantConfirm) {
                <div class="hotel-tour-bar-label hotel-tour-bar-label__instant-confirm">
                    Быстрое подтверждение
                </div>
            }
            @if (isFewAvailableSeats) {
                <div class="hotel-tour-bar-label hotel-tour-bar-label__seats">
                    Мало мест
                </div>
            }

            <div class="hotel-tour-bar-label hotel-tour-bar-label__credit">
                0-0-6
            </div>
        </div>
    </div>

    <div class="hotel-tour__content">
        <div class="hotel-tour__items">
            <div class="hotel-tour__item hotel-tour__item--dates">
                <span class="item-label">Даты</span>
                <div>
                    {{ checkInDate }} - {{ checkOutDate }}
                </div>
            </div>
            <div class="hotel-tour__item hotel-tour__item--days">
                <span class="item-label">Кол-во дней</span>
                {{ tour.nights + 1 }} {{ getDaysLabel(tour.nights + 1) }}
                @if (tour.nightsOnWay) {
                    <span class="hint">
            (+ {{ tour.nightsOnWay }} {{ getNightsLabel(tour.nightsOnWay) }} в пути)
          </span>
                }
            </div>
            @if (tour.meal.name) {
                <div class="hotel-tour__item hotel-tour__item--meal">
                    <span class="item-label">Питание</span>
                    {{ tour.meal.name }}
                </div>
            }
            @if (tour.rooms.length > 0) {
                <div class="hotel-tour__item hotel-tour__item--room">
                    <span class="item-label">Номер</span>
                    {{ getRooms() }}
                </div>
            }
            @if (!isHotelsSearch) {
                @if (tour.flights?.airlines && tour.flights?.airlines.length > 0) {
                    <div class="hotel-tour__item hotel-tour__item--fly">
                        <span class="item-label">{{ transportLabel }}</span>
                        <ul class="airline-list">
                            @for (airline of displayedAirlines; track trackByAirlineId) {
                                <li>
                                    @if (!airline.hasIcon) {
                                        <span>{{ airline.name }}</span>
                                    }
                                    @if (airline.hasIcon) {
                                        <img src="/x-assets/img/airlines/{{airline.code}}.png" title="{{ airline.name }}" alt="{{ airline.name }}">
                                    }
                                </li>
                            }
                        </ul>
                    </div>
                } @else {
                    <div class="hotel-tour__item hotel-tour__item--fly">
                        <span class="item-label">{{ transportLabel }}</span>
                        <ul class="airline-list">
                            <li><span>{{ transportValue }}</span></li>
                        </ul>
                    </div>
                }
            }
        </div>

        <div class="hotel-tour__footer ng-flex">
            <div class="hotel-tour__price show-tour-booking" [attr.data-id]="tour.id">
                @if (getCashback) {
                    <span class="cashback">+ <span>{{ getCashback | priceFormat }}</span> кешбэк</span>
                }
                @if (getOldPrice) {
                    <span class="old-price">{{ getOldPrice | priceFormat:tour.price.currency }}</span>
                }
                <span class="current">{{ tour.price.value | priceFormat:tour.price.currency }}</span>
            </div>

            <div class="buttons">
                @if (isHt) {
                    <button
                        type="button"
                        class="tour-hunter-toggle-btn"
                        [class.add-tracking-tour]="!isTrackingTour"
                        [class.remove-tracking-tour]="isTrackingTour"
                        [attr.data-tour-id]="tour.id"
                        [attr.data-tracking-id]="trackingId"
                        data-place="hotel-tour-card"
                        (click)="$event.stopPropagation()">
                        <img [src]="tourHunterIconSrc" [alt]="tourHunterIconAlt">
                    </button>
                }

                <button type="button"
                        class="hotel-tour-btn-select show-tour-booking"
                        [attr.data-id]="tour.id"
                        (click)="openBookingPage($event)">
                    {{ btnToTourDetailsLabel }}
                </button>
            </div>
        </div>
    </div>

</div>
